// src/utils/structuredData.ts

export const generateOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Regal Outsource (India) Pvt. Ltd.",
  "url": "https://regaloutsourceindia.com",
  "logo": "https://regaloutsourceindia.com/assets/services/regal-logo.png",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91 8829918888",
    "contactType": "Customer Service"
  },
  "sameAs": [
    "https://www.facebook.com/RegalOutSource",
    "https://twitter.com/regaloutsource",
    "https://www.linkedin.com/company/regal-outsource-india"
  ]
});

export const generateWebsiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "url": "https://regaloutsourceindia.com",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://regaloutsourceindia.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
});

export const generateBreadcrumbSchema = (breadcrumbs: Array<{ name: string; url: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((breadcrumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": breadcrumb.name,
    "item": breadcrumb.url
  }))
});

export const generateArticleSchema = (articleDetails: {
  id: string;
  slug: string;
  title: string;
  content: string;
  excerpt: string;
  category: string;
  image: string;
  date: string;
  readTime: string;
  authorRole: string;
  author: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "@id": `https://regaloutsourceindia.com/blog/${articleDetails.slug}#article`,
  "url": `https://regaloutsourceindia.com/blog/${articleDetails.slug}`,
  "headline": articleDetails.title,
  "description": articleDetails.excerpt,
  "image": articleDetails.image,
  "category": articleDetails.category,
  "datePublished": articleDetails.date,
  "readTime": articleDetails.readTime,
  "author": {
    "@type": "Person",
    "role": articleDetails.authorRole,
    "name": articleDetails.author,
  },
  "publisher": {
    "@type": "Organization",
    "name": "Regal Outsource (India) Pvt. Ltd.",
    "logo": {
      "@type": "ImageObject",
      "url": "https://regaloutsourceindia.com/assets/services/regal-logo.png"
    }
  }
});

export const generateLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Regal Outsource (India) Pvt. Ltd.",
  "image": "https://regaloutsourceindia.com/assets/og-image.jpg",
  "url": "https://regaloutsourceindia.com",
  "telephone": "+91 8829918888",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Udaipur, Rajasthan",
    "addressLocality": "Udaipur",
    "addressRegion": "RJ",
    "postalCode": "313003",
    "addressCountry": "IN"
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday"
    ],
    "opens": "08:00",
    "closes": "20:00"
  }
});